export default __webpack_public_path__ + "static/media/about.599c902d.jpg";